import PropTypes from 'prop-types';
import React from 'react';

import Loader from './loader.jsx';
import Title from './title.jsx';
import ManageContentMenu from './manage_content_menu.jsx';
import Section from './section.jsx';
import TermMenu from './term_menu.jsx';
import Navbar from './navbar.jsx';
import UserMenu from './user_menu.ui.jsx';
import env from '../env';

const { SECTION_UA_HOSTS } = env;

function cmp(a, b) {
    if (a === b) {
        return 0;
    }
    return a < b ? -1 : 1;
}

const numbers = /[\d.]+/;
const getters = [
    s => s.course_subject,
    s => {
        const tmp = '' + s.course_catalog_number;
        return parseFloat(tmp.match(numbers));
    },
    s => {
        const tmp = '' + s.class_number;
        return parseFloat(tmp.match(numbers));
    },
];
function sectionSorter(a, b) {
    return getters.reduce((value, get) => {
        if (value === 0) {
            return cmp(get(a), get(b));
        }
        return value;
    }, 0);
}

const currentHosts = SECTION_UA_HOSTS || [];

export default class TermView extends React.Component {
    static displayName = 'TermView';

    static propTypes = {
        currentPath: PropTypes.string.isRequired,
        children: PropTypes.object,
        location: PropTypes.object.isRequired,
        isInstructor: PropTypes.bool.isRequired,
        params: PropTypes.shape({
            termId: PropTypes.string.isRequired,
        }).isRequired,
        sections: PropTypes.any,
        term: PropTypes.any,
        setCurrentTerm: PropTypes.func.isRequired,
        analyticsEvent: PropTypes.func.isRequired,
        helpUrl: PropTypes.string,
        user: PropTypes.shape({
            full_name: PropTypes.string.isRequired,
            email: PropTypes.string.isRequired,
        }).isRequired,
    };

    renderManageContent() {
        if (this.props.isInstructor) {
            return (
                <div className="manage-content-container">
                    <div className="manage-content js-manage-content">
                        <ManageContentMenu
                            currentPath={this.props.currentPath}
                        />
                    </div>
                </div>
            );
        }
    }

    renderSections() {
        const { sections, location } = this.props;

        return sections.sort(sectionSorter).map(section => {
            return (
                <li className="container course-compendium" key={section.id}>
                    <Section
                        section={section}
                        analyticsMode="term"
                        query={location.query}
                    />
                </li>
            );
        });
    }

    // componentDidMount() {
    // const { setCurrentTerm, term } = this.props;
    // setCurrentTerm(term.id);
    // }

    renderUA() {
        if (currentHosts.indexOf(window.location.host) >= 0) {
            return (
                <div id="ua-section">
                    <p>
                        Didn't find all of your eTexts? Make sure you click on
                        the eText link in Canvas for each section you're
                        enrolled in.
                    </p>
                </div>
            );
        }
    }

    render() {
        const id = parseInt(this.props.params.termId, 10);
        const { term, sections } = this.props;

        if (!term || !sections || sections.length !== term.section_ids.length) {
            return <Loader />;
        }
        const { children } = this.props;
        const childComponent = children
            ? React.cloneElement(children, { term })
            : false;

        return (
            <div>
                <Title>{term.name} course materials</Title>
                <Navbar.Proxy showHome={false}>
                    <h1>Term</h1>

                    <div className="term-options js-term-options">
                        <TermMenu value={id} />
                    </div>

                    <div className="pull-right header-right">
                        {this.renderManageContent()}
                        <UserMenu />
                    </div>
                </Navbar.Proxy>
                <div id="terms-container">
                    <ul className="terms">
                        <li>
                            {/* old TermView */}
                            <ul className="sections">
                                {this.renderSections()}
                            </ul>
                        </li>
                    </ul>
                </div>
                {this.renderUA()}
                {childComponent}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/term_view.ui.jsx